import { Observable } from 'rxjs';
import { ExtensionBroker } from '../extension-broker/extension-broker';
import { JobNode } from './models/job-node';
import { JobPaginatedResponse } from './models/job-paginated-response';
import { JobPaginationOptions } from './models/job-pagination-options';
import { PowerShellJob } from './models/powershell-job';

/**
 * Module side interface for job management
 */
export class JobsManager {
    /**
     * Instantiates a new Job Manager instance.
     * @param extensionBroker The extension broker service
     */
    constructor(private extensionBroker: ExtensionBroker) { }

    /**
     * Creates a new powershell job,
     * this is just a stub for the powershell job worker extension
     */
    public createPowerShellJob(job: PowerShellJob): Observable<PowerShellJob> {
        return this.extensionBroker.runWorker('msft.sme.shell-extensions!powerShellJobsWorker', 'createJob', 0, job);
    }

    /**
     * Gets an existing powershell job,
     * this is just a stub for the powershell job worker extension
     */
    public getPowerShellJob(jobId: string): Observable<PowerShellJob> {
        return this.extensionBroker.runWorker('msft.sme.shell-extensions!powerShellJobsWorker', 'getJob', 0, jobId);
    }

    /**
     * Gets an existing powershell job,
     * this is just a stub for the powershell job worker extension
     */
    public getPowerShellJobNodes(jobId: string, options: JobPaginationOptions): Observable<JobPaginatedResponse<JobNode>> {
        return this.extensionBroker.runWorker('msft.sme.shell-extensions!powerShellJobsWorker', 'getJobNodes', 0, jobId, options);
    }

}
